import React from 'react';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';

import VotesTypes from '../../../Utils/Types/VoteTypes';

function EmojiIcon({ reaction, size = 24 }: any) {
  const intl = useIntl();
  const reactions = {
    comment: {
      icon: '💬',
      ariaLabel: `${intl.formatMessage({ id: 'POSTS.INDICATORS.COMMENTS' })} emoji`,
    },
    [VotesTypes.BUDGET]: {
      icon: '🛒',
      ariaLabel: `${intl.formatMessage({ id: 'BUTTONS.VOTE.BUDGET' })} emoji`,
    },
    [VotesTypes.SUPPORT]: {
      icon: '😍',
      ariaLabel: `${intl.formatMessage({ id: 'BUTTONS.VOTE.SUPPORT' })} emoji`,
    },
    [VotesTypes.NOT_SUPPORT]: {
      icon: '🙁',
      ariaLabel: `${intl.formatMessage({ id: 'BUTTONS.VOTE.NOT_SUPPORT' })} emoji`,
    },
  };

  const selectedReaction = reactions[reaction];

  return (
    <div
      role="img"
      aria-label={selectedReaction?.ariaLabel}
      style={{ fontSize: size, marginTop: -1 }}
    >
      {selectedReaction.icon}
    </div>
  );
}

EmojiIcon.propTypes = {
  reaction: PropTypes.oneOf([...Object.values(VotesTypes), 'comment']).isRequired,
  size: PropTypes.number,
};

export default EmojiIcon;
